import React from 'react';
import "./PharmacySelectionConfirmationModal.css";
import Disclaimer from '../../../pages/ChooseTreatmentVariants/components/Disclaimers/Disclaimer';
import { MdInfoOutline } from "react-icons/md";

interface Props{
    closeModal: () => void
    onSubmit: () => void
    selectedPharmacy: ExternalPharmacy
}

const getAvailabilityDisclaimerText = (availability: string) => {
    if (availability == 'NO_INFO') { // No info
        return "Wir haben keine Echtzeit-Lagerinformationen für diese Apotheke. Wenn Sie fortfahren, liegt es in Ihrer Verantwortung, die Verfügbarkeit bei dieser Apotheke zu überprüfen.";
    }

    if (availability === "OUT_OF_STOCK") { // out of stock
        return "Diese Apotheke hat bestätigt, dass das Medikament nicht mehr vorrätig ist. Wenn Sie fortfahren, liegt es in Ihrer Verantwortung, die Verfügbarkeit bei dieser Apotheke zu überprüfen.";
    }

    if (availability === "PARTIAL_STOCK") {
        return "Bitte prüfen Sie die Verfügbarkeit Ihrer Produkte"
    }

    return "";
};


const PharmacySelectionConfirmationModal:React.FC<Props> = ({closeModal,onSubmit,selectedPharmacy}) => {
  return (
    <div onClick={closeModal} className="pharmacy-selection-modal-background" style={{

    }}>
        <div
        className="pharmacy-selection-modal-container"
        onClick={(event) => event.stopPropagation()}
        >   

            {/* Header  */}
            <div className="pharmacy-selection-modal-header">
                <MdInfoOutline size={24} color='white'/>
                <h2>Bestätigung der Auswahl</h2>
                <button className="pharmacy-selection-modal-header-close-btn" onClick={closeModal}>&times;</button>
            </div>


            {/* Body */}
            <div className="pharmacy-selection-modal-header-body">
              <h6>{selectedPharmacy.rejectionCount ? "Die ausgewählte Apotheke hat Ihre Bestellung schon einmal abgelehnt. Möchten Sie Ihr Rezept trotzdem dorthin schicken?" : "Sie haben diese Apotheke zur Abwicklung Ihrer Bestellung ausgewählt:"}</h6>
                <ul>
                    <li className="pharmacy-selection-modal-pharmacy-name">{selectedPharmacy!.name}</li>
                    <li className="pharmacy-selection-modal-pharmacy-address">{selectedPharmacy!.address}</li>
                </ul>

                {getAvailabilityDisclaimerText(selectedPharmacy.availabilityCode)
                    ? <Disclaimer text={getAvailabilityDisclaimerText(selectedPharmacy.availabilityCode)} />
                    : null}

                    {
                        selectedPharmacy.availabilityCode === 'PARTIAL_STOCK' ? 
                        
                        <div className='pharmacy-selection-modal-product-list-container'>
                            {/* Products list with availability  */}
                            <ul className="pharmacy-selection-modal-product-item-list">
                                {selectedPharmacy.productsWithAvailability.map((product: any) => {
                                    const { product_item_id, title, availability } = product;
                                    const isInStock = availability === 1 || availability === 2;
                                    const status = isInStock ? 'Sofort Verfügbar' : 'Nicht lieferbar';
                                    return (
                                        <li  key={product_item_id} className="pharmacy-selection-modal-product-item-row">
                                            <div>
                                                {title}
                                                <span  className={isInStock ? 'pharmacy-selection-modal-in-stock' : 'pharmacy-selection-modal-out-of-stock'}>{status}</span>
                                            </div>
                                        </li>
                                    );
                                })}
                            
                            </ul>

                            {/* Product list with availability Disclaimer  */}
                            <div className='pharmacy-selection-modal-product-list-disclaimer'>Wenn Sie fortfahren, erhalten Sie nur die verfügbaren Produkte. Möglicherweise möchten Sie für alle Produkte eine andere Apotheke auswählen.</div>
                        </div>

                        : null
                    }

                

                <p className='pharmacy-selection-disclaimer'>
                    Klicken Sie auf „Bestätigen“, damit wir Ihr Rezept an die ausgewählte Apotheke senden können, sobald es vom Arzt genehmigt wurde. Sie werden per E-Mail über die Abholung der Bestellung benachrichtigt werden.
                </p>

                <div className="actions-container">
                    <span className="confirm-btn" onClick={onSubmit}>Bestätigen</span>
                    <span className='cancel-btn' onClick={closeModal}>Stornieren</span>
                </div>
            </div>

        </div>
    </div>
  )
}

export default PharmacySelectionConfirmationModal